import { CustomerSubscriptionStatusEnum } from '@fasstech/oip-core/entities/Customer/enums';

const getMessageInfo = (message, subscriptionStatus) => {
  return subscriptionStatus === CustomerSubscriptionStatusEnum.PROSPECT
    ? 'Les frais d’adhésion à l’association GPSI à hauteur de 3 euros seront prélevés en plus de la première cotisation'
    : message;
};

export default getMessageInfo;
